(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.BonanzaOfferCore = api;
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  function record(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
  }

  function cents(value) {
    return Number.isSafeInteger(value) && value >= 0;
  }

  function optionalArray(value) {
    return value === undefined || Array.isArray(value);
  }

  function present(value) {
    return Array.isArray(value) && value.length > 0;
  }

  function result(state, subtotal, discounted, gap) {
    return {
      state: state,
      canApply: state === 'ready',
      subtotalCents: subtotal === undefined ? null : subtotal,
      discountedCents: discounted === undefined ? null : discounted,
      gapCents: gap === undefined ? null : gap
    };
  }

  function validConfig(config) {
    return record(config) && config.enabled === true && config.currency === 'USD' &&
      cents(config.thresholdCents) && config.thresholdCents > 0 &&
      Number.isSafeInteger(config.percent) && config.percent > 0 && config.percent <= 100 &&
      Array.isArray(config.allowedHandles) && config.allowedHandles.length > 0 &&
      config.allowedHandles.every(function (handle) {
        return typeof handle === 'string' && handle.length > 0 && handle.trim() === handle;
      });
  }

  function evaluate(cart, config) {
    if (!validConfig(config) || !record(cart) ||
        typeof cart.currency !== 'string' || !/^[A-Z]{3}$/.test(cart.currency) ||
        !Array.isArray(cart.items) || !cents(cart.item_count) ||
        !cents(cart.original_total_price) || !cents(cart.total_price) || !cents(cart.total_discount) ||
        !optionalArray(cart.cart_level_discount_applications) || !optionalArray(cart.discount_codes)) {
      return result('unavailable');
    }

    var subtotal = 0;
    var finalTotal = 0;
    var quantity = 0;
    var excluded = false;
    var existingDiscount = cart.total_discount > 0 ||
      present(cart.cart_level_discount_applications) || present(cart.discount_codes);

    for (var i = 0; i < cart.items.length; i += 1) {
      var item = cart.items[i];
      if (!record(item) || !cents(item.quantity) || item.quantity === 0 ||
          !cents(item.original_line_price) || !cents(item.final_line_price) ||
          item.final_line_price > item.original_line_price ||
          !optionalArray(item.discounts) || !optionalArray(item.line_level_discount_allocations)) {
        return result('unavailable');
      }

      subtotal += item.original_line_price;
      finalTotal += item.final_line_price;
      quantity += item.quantity;
      if (!cents(subtotal) || !cents(finalTotal) || !cents(quantity)) return result('unavailable');

      if (typeof item.handle !== 'string' || config.allowedHandles.indexOf(item.handle) === -1 ||
          item.gift_card !== false || item.requires_shipping !== true ||
          item.selling_plan_allocation != null || item.original_line_price === 0) {
        excluded = true;
      }
      if (item.final_line_price < item.original_line_price ||
          present(item.discounts) || present(item.line_level_discount_allocations)) {
        existingDiscount = true;
      }
    }

    if (quantity !== cart.item_count || subtotal !== cart.original_total_price ||
        cart.total_price > finalTotal || subtotal - cart.total_price !== cart.total_discount) {
      return result('unavailable');
    }
    if (cart.items.length === 0) return result('empty', 0);
    if (cart.currency !== config.currency) return result('currency');
    if (excluded) return result('excluded', subtotal);
    if (existingDiscount) return result('existing_discount', subtotal);

    var estimatedDiscount = 0;
    for (var j = 0; j < cart.items.length; j += 1) {
      var amount = cart.items[j].original_line_price;
      // Round the estimated discount up per line to avoid overstating the projected subtotal.
      estimatedDiscount += Math.floor(amount / 100) * config.percent +
        Math.ceil((amount % 100) * config.percent / 100);
    }
    var discounted = subtotal - estimatedDiscount;
    var gap = Math.max(0, config.thresholdCents - discounted);
    var state = subtotal >= config.thresholdCents && discounted < config.thresholdCents ? 'shipping_risk' : 'ready';
    return result(state, subtotal, discounted, gap);
  }

  return { evaluate: evaluate };
}));
